import React from 'react';

const LoadingSpinner = () => {
    return (
        <div className="loading-container">
            <div className="spinner"></div>
            <p>Завантаження…</p>
        </div>
    );
};

export default LoadingSpinner;